import axios from 'axios';
import React, { useCallback, useState } from 'react';
import AuthField from './components/AuthField';
import AuthForm from './components/AuthForm';
import AuthPageWrapper from './components/AuthPageWrapper';

export default function ChangePasswordPage({ navTo, resetConfig }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'error' });

  const validateField = (v) => (v ? null : `${v} is required`);

  const handleCancel = async () => {
    setIsLoading(true);
    setCurrentPassword('');
    setNewPassword('');
    setConfirmNewPassword('');
    setAlert({ open: false, message: '', severity: 'error' });
    await axios.post('/conditionalLogout');
    window.location.href = '/';
  };

  const submit = useCallback(
    async (e) => {
      e.preventDefault();
      setAlert((p) => ({ ...p, open: false }));
      setIsLoading(true);
      resetConfig();
      try {
        const { data } = await axios.post(
          '/changePassword',
          { password: currentPassword, newPassword, newPasswordConfirm: confirmNewPassword },
          { validateStatus: () => true }
        );
        if (data.status === 'success') {
          setAlert({ open: true, message: 'Password changed successfully.', severity: 'success' });
          navTo('changePasswordSuccess');
        } else {
          setAlert({ open: true, message: data.error || 'Change failed.', severity: 'error' });
        }
      } catch {
        setAlert({ open: true, message: 'Server error. Try again later.', severity: 'error' });
      } finally {
        setIsLoading(false);
      }
    },
    [currentPassword, newPassword, confirmNewPassword, navTo, resetConfig]
  );

  return (
    <AuthPageWrapper alert={alert} onCloseAlert={() => setAlert((p) => ({ ...p, open: false }))}>
      <AuthForm
        disableSubmit={
          validateField(currentPassword) ||
          validateField(newPassword) ||
          validateField(confirmNewPassword)
        }
        isLoading={isLoading}
        onCancel={handleCancel}
        onSubmit={submit}
        sectionTitle="Change Password"
        submitText={isLoading ? 'Processing...' : 'Change Password'}
      >
        <AuthField
          disabled={isLoading}
          label="Current Password"
          onChange={(e) => setCurrentPassword(e.target.value)}
          type="password"
          value={currentPassword}
        />
        <AuthField
          disabled={isLoading}
          label="New Password"
          onChange={(e) => setNewPassword(e.target.value)}
          type="password"
          value={newPassword}
        />
        <AuthField
          disabled={isLoading}
          label="Confirm New Password"
          onChange={(e) => setConfirmNewPassword(e.target.value)}
          type="password"
          value={confirmNewPassword}
        />
      </AuthForm>
    </AuthPageWrapper>
  );
}
